import {
  Button,
  Card,
  Column,
  Columns,
  Heading,
  Stack,
  Text,
} from "@origin-digital/ods-core";
import React from "react";
import { IReportSection } from "./types";
import { apiClient } from "../../api/apiService";

const CustomerCompanyReportSection = ({
  setUnableToDownload,
}: IReportSection) => {
  const downloadCustomersAndCompaniesReport = async () => {
    try {
      const response = await apiClient.get(
        "/reports/user-company-relationships",
        {
          responseType: "blob",
        }
      );
      const url = window.URL.createObjectURL(
        new Blob([response.data], { type: "text/csv" })
      );
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "customers-companies.csv");
      document.body.appendChild(link);
      link.click(); // Trigger the download
      link.remove();
      setUnableToDownload(false);
    } catch (e) {
      setUnableToDownload(true);
    }
  };

  return (
    <Card>
      <Columns
        collapseBelow="md"
        space={{
          xs: "xsmall",
          md: "medium",
        }}
      >
        <Column width="2/3">
          <Stack space="large">
            <Heading variant="h4" component="h1">
              All customers and companies
            </Heading>
            <Text>
              Download a CSV file of all customers and companies in Origin
              Connect.
            </Text>
            <Button
              aria-label="Download customers and companies"
              onClick={downloadCustomersAndCompaniesReport}
            >
              Download
            </Button>
          </Stack>
        </Column>
        <Column width="1/3" />
      </Columns>
    </Card>
  );
};

export default CustomerCompanyReportSection;
